export default {
  FETCHED_ALL: 'FETCHED_ALL_VARIABLES',
  FETCHED_MULTIPLE: 'FETCHED_VARIABLES',
  FETCHED_SINGLE: 'FETCHED_VARIABLE',
  DELETED_SINGLE: 'DELETED_VARIABLE',
};
